import React from "react";

import { isDefined } from "@utils/helpers";
import { formatPrice } from "@utils/productPrice";

import TotalsRowComponent from "./totalsRow.component";

type TotalsBlockComponentProps = {
    subTotal?: number | null;
    deliveryCost?: number | null;
    discountTotal?: number | null;
    giftCardTotal?: number | null;
    serviceTotal?: number | null;
    totalPrice?: number | null;
};

const TotalsBlockComponent = ({
    subTotal,
    deliveryCost,
    discountTotal,
    giftCardTotal,
    serviceTotal,
    totalPrice,
}: TotalsBlockComponentProps) => (
    <div>
        {serviceTotal && (
            <TotalsRowComponent
                label={"general.miniCart.totals.serviceTotal"}
                value={formatPrice(serviceTotal)}
            />
        )}
        <TotalsRowComponent
            label={"general.miniCart.totals.subTotal"}
            value={formatPrice(subTotal)}
        />
        {isDefined(deliveryCost) && (
            <TotalsRowComponent
                label={"general.miniCart.totals.deliveryCost"}
                value={formatPrice(deliveryCost, true)}
            />
        )}
        {discountTotal && (
            <TotalsRowComponent
                label={"general.miniCart.totals.globalDiscounts"}
                value={`-${formatPrice(discountTotal)}`}
            />
        )}
        {giftCardTotal && (
            <TotalsRowComponent
                label={"general.miniCart.totals.paidByGiftCard"}
                value={`-${formatPrice(giftCardTotal)}`}
            />
        )}
        <TotalsRowComponent
            label={"general.miniCart.totals.totalPrice"}
            value={formatPrice(totalPrice)}
            isTotalPrice={true}
        />
    </div>
);

export default TotalsBlockComponent;
